import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";

export default function ProtectedRoute({ children, roles }) {
  const { user, loading } = useAuth();

  if (loading || user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background" data-testid="route-loading">
        <Loader2 className="h-8 w-8 animate-spin text-primary" />
      </div>
    );
  }
  if (!user) {
    const next = `${window.location.pathname}${window.location.search}`;
    if (next !== "/" && !next.startsWith("/login")) sessionStorage.setItem("kc_next", next);
    return <Navigate to="/login" replace />;
  }
  if (roles && !roles.includes(user.role)) {
    const home = user.role === "admin" ? "/admin" : user.role === "driver" ? "/driver" : "/dashboard";
    return <Navigate to={home} replace />;
  }
  return children;
}
